import { IEnvironment } from 'config/env';

const environment: IEnvironment = {
  ENV: 'dev',
  GQL_URL: 'https://api.dev.ef.studio.ef.com.cn/gipfeli/',
  MEDIA_URL: 'https://teach-assets.dev.ef.studio.ef.com.cn',
  TF_SVCGATEWAY_URL: 'https://api.dev.ef.studio.ef.com.cn/teacher-first',
  TEACHER_CHATBOT_URL: 'https://teaching-assistant.ai.qa.better.efekta.com/',
  CATALYST_PLAYER_URL: 'https://lesson-player.dev.ef.studio/?product=gap-b2b',
  CONTENT_PREVIEW_URL: 'https://content-preview.dev.ef.studio/',
  ENTRY_STATUS_INTERVAL: 2e4,
  AVAILABILITY_INTERVAL: 1e4,
  BOOKING_INTERVAL: 1e4,
  USER_INTERVAL: 6e5,
  UNCLAIMED_LESSONS_INTERVAL: 1e4,
  DISCONNECT_AFTER: 3e5,
  HELP_CENTER_URL: 'https://ef-teachonline--uat.sandbox.my.site.com',
  HC_PREVIEW_URL: 'https://evc.ef.com.cn/evc15/meeting/home/hc-preview#/topic',
  ACR_TODO_INTERVAL: 6e4,
  LESSON_DEFINITION_INTERVAL: 6e4,
  TECH_CHECK_URL_TEMPLATE:
    'https://evc.ef.com/evc15/meeting/tools/teachertechcheck?proxyInfo=&centerCode=UK#ret={0};s=304615050;m=35754986;cc=en;host=axis.eflabs.io;canskip=true',
  LOGIN: {
    SIGNIN_SIGNUP_USER_FLOW: 'B2C_1_Teacher_First_Non_Prod',
    RESET_USER_FLOW: 'B2C_1_Teacher_First_Non_Prod',
    AUTHORITY_BASE_URL: 'https://efiddev.b2clogin.com/efiddev.onmicrosoft.com/',
    TOKEN_SCOPE: 'https://efiddev.onmicrosoft.com/tfapi/tfapi.readwrite',
    CLIENT_ID: '6f1ca649-b440-4c02-8e43-f65e4e493ca5',
  },
  DATADOG: {
    APPLICATION_ID: '9d00dff8-74e2-4ba3-b391-1fdd000b21aa',
    CLIENT_TOKEN: 'pub0242cd2f1e3f4db91a4a78865b52fe00',
    SERVICE_NAME: 'teacher-first-fe',
    VIRTUAL_ENV: 'dev',
  },
  API_KEYS: {},
  EVC_TUNNELS: {
    US_NV: 'https://dev.evc.ef.com',
    CN_SH: 'https://dev.evc.ef.com.cn',
    JP_TYO: 'https://jp.dev.hc.efekta.com',
  },
  STORYBLOK: {
    TOKEN: 'F3r4jM0RH8JZjLE0ke3fFAtt',
    VERSION: 'draft',
  },
};

export default environment;
